exports.themes = [

    {
        name: 'White',

        primary: '#cacaca',
        secondary: '#cacaca',

        menu_background: '#f4f4f5',
        content_surface_background: "#ededed",
        menu_color: '#7e8190',
        menu_color_selected: '#b71b54',
        menu_color_hover: '#bb7991',
        
        content_background: '#FFF',
        content_color: '#60616d',
        content_color_selected: '#000',

        borders: '#cacaca',

        error: 'red',
        success: 'green',
    },

    { 
        name: 'Black',

        primary: '#b71b54',
        secondary: '#fff',

        menu_background: '#242635',
        menu_color: '#767888',
        menu_color_selected: '#fff',
        menu_color_hover: '#b0b2bf',

        content_background: '#1c1e2d',
        content_surface_background: "#313347",
        content_color: '#767888',
        content_color_selected: '#fff',

        borders: '#333543',
        
        error: 'red',
        success: 'green',
    },

    { 
        name: 'fifiblack',

        primary: '#007aff',
        secondary: '#fff',

        menu_background: '#242635',
        menu_color: '#767888',
        menu_color_selected: '#fff',

        content_background: '#1c1e2d',
        content_surface_background: "#313347",
        content_color: '#767888',
        content_color_selected: '#fff',
        menu_color_hover: '#b0b2bf',

        borders: '#333543',
        
        error: 'red',
        success: 'green',
    },

]
 